import React from "react";
import { Link } from "react-router-dom";

const Privacy = props => (
  <div className="section is-medium">
    <div className="container content">
      <h1 className="title is-4">Privacy Policy</h1>
      <p className="content">
        This privacy policy has been compiled to better serve those who are
        concerned with how their 'Personally Identifiable Information' (PII) is
        being used online. PII, as described in US privacy law and information
        security, is information that can be used on its own or with other
        information to identify, contact, or locate a single person, or to
        identify an individual in context. Please read our privacy policy
        carefully to get a clear understanding of how we collect, use, protect
        or otherwise handle your Personally Identifiable Information in
        accordance with our website.
      </p>
      <p className="content">
        <strong>
          What personal information do we collect from the people that visit our
          blog, website or app?
        </strong>
      </p>
      <p className="content">
        When ordering or registering on our site, as appropriate, you may be
        asked to enter your name, email address, mailing address, phone number
        or other details to help you with your experience.
      </p>
      <p className="content">
        <strong>When do we collect information?</strong>
      </p>
      <p className="content">
        We collect information from you when you subscribe to a newsletter, fill
        out a form or enter information on our site.
      </p>
      <p className="content">
        <strong>How do we use your information?</strong>
      </p>
      <p className="content">
        We may use the information we collect from you when you register, make a
        purchase, sign up for our newsletter, respond to a survey or marketing
        communication, surf the website, or use certain other site features in
        the following ways:
        <ul>
          <li>
            To allow us to better service you in responding to your customer
            service requests.
          </li>
          <li>
            To send periodic emails regarding your order or other products and
            services.
          </li>
          <li>
            To follow up with them after correspondence (live chat, email or
            phone inquiries)
          </li>
        </ul>
      </p>
      <p className="content">
        <strong>How do we protect your information?</strong>
      </p>
      <p className="content">
        We do not use vulnerability scanning and/or scanning to PCI standards.
      </p>
      <p className="content">
        We only provide articles and information. We never ask for credit card
        numbers.
      </p>
      <p className="content">We use regular Malware Scanning.</p>
      <p className="content">
        Your personal information is contained behind secured networks and is
        only accessible by a limited number of persons who have special access
        rights to such systems, and are required to keep the information
        confidential. In addition, all sensitive/credit information you supply
        is encrypted via Secure Socket Layer (SSL) technology.
      </p>
      <p className="content">
        We implement a variety of security measures when a user enters, submits,
        or accesses their information to maintain the safety of your personal
        information.
      </p>
      <p className="content">
        All transactions are processed through a gateway provider and are not
        stored or processed on our servers.
      </p>
      <p className="content">
        <strong>Do we use 'cookies'?</strong>
      </p>
      <p className="content">
        Yes. Cookies are small files that a site or its service provider
        transfers to your computer's hard drive through your Web browser (if you
        allow) that enables the site's or service provider's systems to
        recognize your browser and capture and remember certain information. For
        instance, we use cookies to help us remember and process the items in
        your shopping cart. They are also used to help us understand your
        preferences based on previous or current site activity, which enables us
        to provide you with improved services. We also use cookies to help us
        compile aggregate data about site traffic and site interaction so that
        we can offer better site experiences and tools in the future.
      </p>
      <p className="content">
        We use cookies to:
        <ul>
          <li>
            Compile aggregate data about site traffic and site interactions in
            order to offer better site experiences and tools in the future. We
            may also use trusted third-party services that track this
            information on our behalf.
          </li>
        </ul>
      </p>
      <p className="content">
        You can choose to have your computer warn you each time a cookie is
        being sent, or you can choose to turn off all cookies. You do this
        through your browser settings. Since browser is a little different, look
        at your browser's Help Menu to learn the correct way to modify your
        cookies.
      </p>
      <p className="content">
        If you turn cookies off, Some of the features that make your site
        experience more efficient may not function properly.It won't affect the
        user's experience that make your site experience more efficient and may
        not function properly.
      </p>
      <p className="content">
        <strong>Third-party disclosure</strong>
      </p>
      <p className="content">
        We do not sell, trade, or otherwise transfer to outside parties your
        Personally Identifiable Information unless we provide users with advance
        notice. This does not include website hosting partners and other parties
        who assist us in operating our website, conducting our business, or
        serving our users, so long as those parties agree to keep this
        information confidential. We may also release information when it's
        release is appropriate to comply with the law, enforce our site
        policies, or protect ours or others' rights, property or safety.
      </p>
      <p className="content">
        However, non-personally identifiable visitor information may be provided
        to other parties for marketing, advertising, or other uses.
      </p>
      <p className="content">
        <strong>Third-party links</strong>
      </p>
      <p className="content">
        Occasionally, at our discretion, we may include or offer third-party
        products or services on our website. These third-party sites have
        separate and independent privacy policies. We therefore have no
        responsibility or liability for the content and activities of these
        linked sites. Nonetheless, we seek to protect the integrity of our site
        and welcome any feedback about these sites.
      </p>
      <p className="content">
        <strong>Google</strong>
      </p>
      <p className="content" />
      Google's{" "}
      <a href="https://support.google.com/adwordspolicy/answer/1316548?hl=en">
        advertising requirements{" "}
      </a>
      can be summed up by Google's Advertising Principles. They are put in place
      to provide a positive experience for users.
      <p className="content">
        We have not enabled Google AdSense on our site but we may do so in the
        future.
      </p>
      <p className="content">
        <strong>California Online Privacy Protection Act</strong>
      </p>
      <p className="content">
        CalOPPA is the first state law in the nation to require commercial
        websites and online services to post a privacy policy. The law's reach
        stretches well beyond California to require any person or company in the
        United States (and conceivably the world) that operates websites
        collecting Personally Identifiable Information from California consumers
        to post a conspicuous privacy policy on its website stating exactly the
        information being collected and those individuals or companies with whom
        it is being shared. - See more at:
        http://consumercal.org/california-online-privacy-protection-act-caloppa/#sthash.0FdRbT51.dpuf
      </p>
      <p className="content">
        According to CalOPPA, we agree to the following:
        <ul>
          <li>Users can visit our site anonymously.</li>
          <li>
            Once this privacy policy is created, we will add a link to it on our
            home page or as a minimum, on the first significant page after
            entering our website.
          </li>
          <li>
            Our Privacy Policy link includes the word 'Privacy' and can easily
            be found on the page specified above
          </li>
        </ul>
      </p>
      <p className="content">
        You weill be notified of any Privacy Policy changes:
        <ul>
          <li>On our Privacy Policy page</li>
        </ul>
      </p>
      <p className="content">
        Can change your personal information:
        <ul>
          <li>By emailing us</li>
        </ul>
      </p>
      <p className="content">
        <strong>How does our site handle Do Not Track signals?</strong>
      </p>
      <p className="content">
        We honor Do Not Track signals and Do Not Track, plant cookies, or use
        advertising when a Do Not Track (DNT) browser mechanism is in place.
      </p>
      <p className="content">
        <strong>Does our site allow third-party behavioral tracking?</strong>
      </p>
      <p className="content">
        It's also important to note that we do not allow third-party behavioral
        tracking.
      </p>
      <p className="content">
        <strong>COPPA (Children Online Privacy Protection Act)</strong>
      </p>
      <p className="content">
        When it comes to the collection of personal information from children
        under the age of 13 years old, the Children's Online Privacy Protection
        Act (COPPA) puts parents in control. The Federal Trade Commission,
        United States' consumer protection agency, enforces the COPPA Rule,
        which spells out what operators of websites and online services must do
        to protect children's privacy and safety online.
      </p>
      <p className="content">
        We do not specifically market to children under the age of 13 years old.
      </p>
      <p className="content">
        <strong>Fair Information Practices</strong>
      </p>
      <p className="content">
        The Fair Information Practices Principles form the backbone of privacy
        law in the United States and the concepts they include have played a
        significant role in the development of data protection laws around the
        globe. Understanding the Fair Information Practice Principles and how
        they should be implemented is critical to comply with the various
        privacy laws that protect personal information.
      </p>
      <p className="content">
        In order to be in line with Fair Information Practices we will take the
        following responsive action, should a data breach occur:
        <ul>
          <li>Within 7 business days</li>
        </ul>
      </p>
      <p className="content">
        We also agree to the Individual Redress Principle which requires that
        individuals have the right to legally pursue enforceable rights against
        data collectors and processors who fail to adhere to the law. This
        principle requires not only that individuals have enforceable rights
        against data users, but also that individuals have recourse to courts or
        government agencies to investigate and/or prosecute non-compliance by
        data processors.
      </p>
      <p className="content">
        <strong>CAN SPAM Act</strong>
      </p>
      <p className="content">
        The CAN-SPAM Act is a law that sets the rules for commercial email,
        establishes requirements for commercial messages, gives recipients the
        right to have emails stopped from being sent to them, and spells out
        tough penalties for violations.
      </p>
      <p className="content">
        We collect your email address in order to:
        <ul>
          <li>
            Send information, respond to inquiries, and/or other requests or
            questions.
          </li>
          <li>
            Proecess orders and to send information ad updates pertaining to
            orders.
          </li>
          <li>
            Market to our mailing list or continue to send emails to our clients
            after the original transaction has occurred.
          </li>
        </ul>
      </p>
      <p className="content">
        To be in accordance with CANSPAM, we agree to the following:
        <ul>
          <li>Not use false or misleading subjects or email addresses.</li>
          <li>
            Identify the message as an advertisement in some reasonable way.
          </li>
          <li>
            Include the physical address of our business or site headquarters.
          </li>
          <li>
            Monitor third-party email marketing services for compliance, if one
            is used.
          </li>
          <li>Honor opt-our/unsubscribe requests quickly.</li>
          <li>
            Allow users to unsubscribe by using the link at the bottom of each
            email.
          </li>
        </ul>
      </p>
      <p className="content">
        If at any time you would like to unsubscribe from receiving future
        emails, you can email us at:
        <ul>
          <li>Follow the instructions at the bottom of each email.</li>
        </ul>
      </p>
      and we will promptly remove you from ALL correspondence.
      <p className="content">
        <strong>Contacting Us</strong>
      </p>
      <p className="content">
        If there are any questions regarding this privacy policy, you may
        contact us using the information below.
      </p>
      <p className="heading">Accratronics Seals, LLC.</p>
      <a
        className="heading"
        href="https://www.google.com/maps/place/2211+Kenmere+Ave,+Burbank,+CA+91504/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <br />
        2211 Kenmere Ave
        <br />
        Burbank, CA 91504
        <br />
        United States
        <br />
      </a>
      <a className="heading" href="mailto:businessdevelopment@accratronics.com">
        businessdevelopment@accratronics.com
      </a>
      <br />
      <Link to="/" className="button is-brand">
        Go Back
      </Link>
    </div>
  </div>
);

export default Privacy;



// WEBPACK FOOTER //
// ./src/pages/Privacy.js